var React = require('react');

function ArrowBottom (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"arrow-bottom"),React.createElement("path",{"d":"M274.454 366.481v0l234.294-234.294c1.235-1.417 2.317-3.019 3.191-4.745l0.061-0.132h-28.128l-227.791 227.791-227.953-227.791h-28.128c1.016 1.855 2.094 3.451 3.3 4.939l-0.047-0.060 252.667 252.341z","key":1})]);
}

ArrowBottom.defaultProps = {"version":"1.1","width":"512","height":"512","viewBox":"0 0 512 512"};

module.exports = ArrowBottom;

ArrowBottom.default = ArrowBottom;
